import React from "react";
import { StyleSheet, View } from "react-native";
import SCheckbox from "styled42/components/SCheckbox";
import S3Image from "screens/common/S3Image";
import SText from "styled42/components/SText";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";

const WhatsappComponent = ({
  whatsappSubscribed,
  Current_Page,
  Page_Modal,
  setSubscription
}) => (
  <View style={styles.applicationUpdates}>
    <SCheckbox
      checked={whatsappSubscribed}
      onClick={() => {
        pushClevertapEvent("loginRegister Clicks", {
          Current_Page: Current_Page,
          Page_Modal: Page_Modal,
          Type: whatsappSubscribed
            ? "WhatsApp Updates - Uncheck"
            : "WhatsApp Updates - Check"
        });
        setSubscription(!whatsappSubscribed);
      }}
    />
    <View style={styles.whatsappIconContainer}>
      <SText size={12}>
        {VernacManager.translateString("new_onboarding_get_update")}
      </SText>
      <S3Image
        path="OlxIntegration"
        name="whatsapp-icon"
        style={styles.whatsappIcon}
      />
      <SText size={12}>
        {VernacManager.translateString("new_onboarding_whatsapp_also")}
      </SText>
    </View>
  </View>
);

const styles = StyleSheet.create({
  applicationUpdates: {
    backgroundColor: "transparent",
    paddingTop: 12,
    // paddingLeft: 8,
    // paddingRight: 16,
    paddingHorizontal: 20,
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  whatsappIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    paddingHorizontal: 10
  },
  whatsappIcon: {
    width: 20,
    height: 20,
    marginHorizontal: 2
  }
});

export default WhatsappComponent;
